import { Link } from 'react-router-dom';
import { useTranslation } from '@mypoz/i18n';
import { EmptyState } from '@mypoz/ui';

import { buttonClass } from '@/lib/styles.js';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <EmptyState
      icon="explore_off"
      title={t('notFound.title')}
      description={t('notFound.body')}
      action={
        <Link to="/" className={buttonClass('secondary')}>
          {t('notFound.cta')}
        </Link>
      }
    />
  );
}
